import { Suspense, useMemo } from 'react';

import Loading from '@/components/shared/Loading';
import useDirection from '@/utils/hooks/useDirection';
// Removed useLocale - landing pages are English-only, saves ~17KB (i18next)

import BlankLayout from './BlankLayout';

// Import layouts directly instead of lazy loading

const Layout = () => {
	useDirection();

	const AppLayout = useMemo(() => {
		return BlankLayout;
	}, []);

	return (
		<Suspense
			fallback={
				<div className="flex flex-auto flex-col h-[100vh]">
					<Loading loading={true} />
				</div>
			}
		>
			<AppLayout />
		</Suspense>
	);
};

export default Layout;
